module.exports = __webpack_public_path__ + "img/uwu_mc5wo.wam.09cc456.png";